import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import SEO from '../../components/SEO';
import { postsData } from '../../data/postsData';
import './PostDetail.css';

const PostDetail: React.FC = () => {
    const { postId } = useParams<{ postId: string }>();
    const navigate = useNavigate();

    const post = postsData.find(p => p.id === postId);

    if (!post) {
        return (
            <div className="main-content-container">
                <div className="page-header">Статья не найдена</div>
                <div className="post-detail">
                    <button className="back-to-categories" onClick={() => navigate('/materials/articles')}>
                        ← Назад к статьям
                    </button>
                </div>
            </div>
        );
    }

    return (
        <>
            <SEO
                title={post.seoTitle}
                description={post.seoDescription}
                keywords={post.keywords}
                canonical={`/materials/article/${post.id}`}
                jsonLd={{
                    "@context": "https://schema.org",
                    "@type": "Article",
                    "headline": post.title,
                    "description": post.seoDescription,
                    "author": {
                        "@type": "Person",
                        "name": "Ольга Гальперина",
                        "jobTitle": "Онкопсихолог"
                    },
                    "datePublished": post.publishDate,
                    "publisher": {
                        "@type": "Person",
                        "name": "Ольга Гальперина"
                    }
                }}
            />
            <div className="main-content-container">
                <div className="page-header">Статьи</div>
                <div className="post-detail">
                    <button className="back-to-categories" onClick={() => navigate('/materials/articles')}>
                        ← Назад к статьям
                    </button>

                    <article>
                        <div className="post-detail-header">
                            <h1 className="post-detail-title">{post.title}</h1>
                            <div className="post-detail-meta">
                                <span>📖 {post.readTime}</span>
                            </div>
                        </div>

                        {post.imageUrl && (
                            <img
                                src={post.imageUrl}
                                alt={post.imageAlt || post.title}
                                className="post-detail-image"
                            />
                        )}

                        {post.content.map((section, index) => (
                            <div key={index} className="post-detail-section">
                                {section.heading && (
                                    <h2 className="post-detail-section-title">{section.heading}</h2>
                                )}
                                <div className="post-detail-text" dangerouslySetInnerHTML={{ __html: section.text }} />
                            </div>
                        ))}
                    </article>

                    <div className="post-detail-cta">
                        <div className="post-detail-cta-text">
                            Если вам нужна профессиональная поддержка — я буду рада помочь.
                        </div>
                        <button
                            className="post-detail-cta-button"
                            onClick={() => navigate('/contact', { state: { serviceType: 'Онкопсихология' } })}
                        >
                            Записаться на консультацию
                        </button>
                    </div>
                </div>
            </div>
        </>
    );
};

export default PostDetail;
